import { html, TemplateResult } from 'lit';
import { PropertyDataUpdateLatch } from '../../api/get-calendar-data-for-house';
import { BookingRequest, Dispatcher } from '../../types/booking-request';
import { WPContent, WPHousePosts } from '../../types/wp-data';
import { stepAvailability } from './step-availability';
import { stepPersonalDetails } from './step-personal-details';
import { stepSelectAHouse } from './step-select-a-house';
import { stepSummary } from './step-summary';
import { stepThankYou } from './step-thank-you';

export function steps(
	state: BookingRequest,
	dispatch: Dispatcher,
	propertyDataUpdateLatch: PropertyDataUpdateLatch,
	assetUrl: string,
	content: WPContent,
	posts: WPHousePosts
): TemplateResult {
	return html`
		${stepSelectAHouse( state, dispatch, propertyDataUpdateLatch, content, posts )}
		${stepAvailability( state, dispatch, propertyDataUpdateLatch, assetUrl, content )}
		${stepSummary( state, dispatch, content, posts )}
		${stepPersonalDetails( state, dispatch, assetUrl, content )}
		${stepThankYou( state, content )}
	`;
}
